import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios"; // Import axios
import { baseurl } from "../../component/Baseurl";

function AdminLogin() {
  // State to hold the selected background class
  const [bgClass, setBgClass] = useState("");

  // Form input states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // State for navigation
  const navigate = useNavigate();

  // Array of available background classes
  const bgClasses = ["bgban3", "bgban4", "bgban5"];

  // Select a random background class on component mount
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * bgClasses.length);
    setBgClass(bgClasses[randomIndex]);
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form refresh
  
    try {
      // Data to send to backend
      const payload = {
        email: email,
        password: password,
      };
  
      // POST request to backend
      const response = await axios.post(`${baseurl}admin-login`, payload);
  
      // Log the response from the backend
      console.log("Response:", response.data);
  
      // Store adminId and email in localStorage
      if (response.data.adminId && response.data.email) {
        localStorage.setItem("adminId", response.data.adminId);
        localStorage.setItem("email", response.data.email);
      }
  
      // Redirect to admin dashboard after successful login
      navigate("/admin-dashboard"); // Navigate to the admin dashboard route
    } catch (error) {
      // Log any errors
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div
        className={`container-fluid login-container d-flex justify-content-center align-items-center ${bgClass}`}
      >
        <div className="login-card shadow form-container">
          <h3 className="text-center mb-4">Admin Login</h3>
          <form className="" onSubmit={handleSubmit}>
            {/* Email Input */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                className="form-control input-field"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)} // Update email state
                required
              />
            </div>

            {/* Password Input */}
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control input-field"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // Update password state
                required
              />
            </div>

            {/* Forgot Password Link */}
            <div className="text-end">
              <Link to="/forget-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div>

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary w-100 login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default AdminLogin;
